import RecapProductList from 'components/Content/Recap/RecapProductList/RecapProductList';
import { withRecapProductListSaleProps } from 'components/Content/Recap/RecapProductListSale/withRecapProductListSaleProps';

export default withRecapProductListSaleProps(RecapProductList);
